import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { IN_SEAT } from '../../constants/dropdownConstants';
import NotesSection from '../NotesSection/NotesSection';
import { useMosaicContext } from '../../contexts/mosaicContext';

const ChildAgeNote = ({ infants, children }) => {
  const isMosaicDesign = useMosaicContext();
  const hasInfantInSeat = infants.includes(IN_SEAT);

  return (
    <>
      {isMosaicDesign ? (
        <NotesSection id="note_child_turns_two" />
      ) : (
        <div className="flex flex-row pad-1-b">
          <p>
            <span className="legal-1">
              <FormattedMessage id="note_child_turns_two" />
            </span>
          </p>
        </div>
      )}
      {children}
      {hasInfantInSeat && (
        isMosaicDesign ? (
          <NotesSection id="infant_in_seat_note" />
        ) : (
          <div className="flex flex-row pad-1-b">
            <p>
              <b>
                <FormattedMessage id="infant_in_seat" />
              </b>
                &nbsp;
              <span className="legal-1">
                <FormattedMessage id="an_infant_for_whom" />
              </span>
            </p>
          </div>
        )
      )}
    </>
  );
};

ChildAgeNote.propTypes = {
  infants: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.arrayOf(PropTypes.element),
};

export { ChildAgeNote as TestableChildAgeNote };

export default ChildAgeNote;
